import { Component, OnInit, OnChanges, Input, ViewChild } from '@angular/core';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color} from 'ng2-charts';

@Component({
  selector: 'app-pareto-chart',
  templateUrl: './pareto-chart.component.html',
  styleUrls: ['./pareto-chart.component.scss']
})
export class ParetoChartComponent implements OnChanges {
  @Input() chartData: any[] = [];
  @ViewChild('pChart', {static: true}) pChart: any;

  ratings = [];
  times = [];

  lineChartData: ChartDataSets[] = [];
  lineChartLabels: Array<any> = [];
  lineChartOptions: any = {
    tooltips: {
      // Disable the on-canvas tooltip
      enabled: false,

      custom: function(tooltipModel) {
        // Tooltip Element
         var tooltipEl = document.getElementById('chartjs-tooltip');
     
         // Create element on first render
         if (!tooltipEl) {
             tooltipEl = document.createElement('div');
             tooltipEl.id = 'chartjs-tooltip';
             tooltipEl.innerHTML = '<table></table>';
             document.body.appendChild(tooltipEl);
         }
     
         // Hide if no tooltip
         if (tooltipModel.opacity === 0) {
             tooltipEl.style.opacity = '0';
             return;
         }
     
         // Set caret Position
         tooltipEl.classList.remove('above', 'below', 'no-transform');
         if (tooltipModel.yAlign) {
             tooltipEl.classList.add(tooltipModel.yAlign);
         } else {
             tooltipEl.classList.add('no-transform');
         }
     
         function getBody(bodyItem) {
             return bodyItem.lines;
         }
     
         // Set Text
         if (tooltipModel.body) {
             var titleLines = tooltipModel.title || [];
             var bodyLines = tooltipModel.body.map(getBody);
     
             var innerHtml = '<thead>';
     
             let questionNo;
             titleLines.forEach(function(title) {
                 questionNo = title.slice(0, 1) + 1 + title.slice(1);;
                 const questionInfo = window['customChartData'].find(item => item._id === questionNo);
                 if (questionInfo) {
                  title += ': ' + questionInfo.question.split('.')[1];
                }
                
                 innerHtml += '<tr><th>' + title + '</th></tr>';
             });
             innerHtml += '</thead><tbody>';
             
             bodyLines.forEach(function(body, i) {
                 var colors = tooltipModel.labelColors[i];
                 var style = 'background:' + colors.backgroundColor;
                 style += '; border-color:' + colors.borderColor;
                 style += '; border-width: 2px';
                 var span = '<span style="' + style + '"></span>';
                 innerHtml += '<tr><td>' + span + 'Avg. Rating: ' +body + '</td></tr>';
             });
            
             innerHtml += '</tbody>';
     
             var tableRoot = tooltipEl.querySelector('table');
             tableRoot.innerHTML = innerHtml;
         }
     
         // `this` will be the overall tooltip
         var position = this._chart.canvas.getBoundingClientRect();
     
         // Display, position, and set styles for font
         tooltipEl.style.opacity = '0.7';
         tooltipEl.style.position = 'absolute';
         tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
         tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
         tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
         tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
         tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
         tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
         tooltipEl.style.pointerEvents = 'none';
         tooltipEl.style.backgroundColor = '#000';
         tooltipEl.style.color = '#fff';
         tooltipEl.style.borderRadius = '5px';
     }
    },
    responsive: true,
    legend: {
      display: false
    },
    scales: {
      yAxes: [{id: 'y-axis-1', type: 'linear', position: 'left', ticks: {min: 0, max: 5},
      scaleLabel: {display: true, labelString: 'Ratings'}}],
      xAxes: [{scaleLabel: {display: true, labelString: 'Questions'} }]
    },
    maintainAspectRatio: false
  };
  lineChartLegend = true;
  lineChartType = 'line';
  public lineChartPlugins = [];
  public lineChartColors: Color[] = [];
  constructor() { }

  ngOnChanges() {
    
    this.ratings = [];
    this.times = [];
    this.chartData.forEach(data => {
      const arr = data.question.split('.');
      this.ratings.unshift(data.avgRating); // , 
      this.times.unshift(data._id.slice(0, 1) + data._id.slice(2));
    })
    console.log('pareto chart', this.chartData);
    window['customChartData'] = this.chartData;
    this.setLineData(this.ratings, this.times);
  }

  setLineData(ratings: number[], labels: string[]) {
    // ratings = ratings.reverse();
    // labels = labels.reverse();
    console.log(ratings, labels);
    this.lineChartData = [
      {
        type: 'line',
        data:  ratings,
        pointRadius: 5,
        fill: false
      },
      {
        type: 'bar',
        data:  ratings,
      },
    ];
    this.lineChartLabels = labels;
  }

  
}




